
export const getCurrentWebsite = (): string => {
	const domain = window.location.hostname;
	let websiteCode;
	switch (domain) {
		case 'huopenair.com':
			websiteCode = 'HU'
			break
		case 'altomincio.humancompany.com':
		case 'altomincio.huopenair.com':
			websiteCode = 'AM'
			break
		case 'venezia.humancompany.com':
		case 'venezia.huopenair.com':
			websiteCode = 'JO'
			break
		case 'firenze.humancompany.com':
		case 'firenze.huopenair.com':
			websiteCode = 'CF'
			break
		case 'norcenni.humancompany.com':
		case 'norcenni.huopenair.com':
			websiteCode = 'NG'
			break
		case 'parkalbatros.humancompany.com':
		case 'parkalbatros.huopenair.com':
			websiteCode = 'PA'
			break
		case 'montescudaio.humancompany.com':
		case 'montescudaio.huopenair.com':
			websiteCode = 'MS'
			break
		case 'roma.humancompany.com':
		case 'roma.huopenair.com':
			websiteCode = 'RO'
			break
		case 'fabulous.humancompany.com':
		case 'fabulous.huopenair.com':
			websiteCode = 'FA'
			break
		case 'ipini.humancompany.com':
		case 'ipini.huopenair.com':
			websiteCode = 'IP'
			break
		case 'birkelt.humancompany.com':
		case 'birkelt.huopenair.com':
			websiteCode = 'BK'
			break
		case 'humantravel.com':
		case 'www.humantravel.com':
			websiteCode = 'EV'
			break
		case 'humancompany.com':
			websiteCode = 'HU'
			break
		case 'firenzecertosacamping.com':
			websiteCode = 'CE'
			break
		case 'palagina.it':
		case 'www.palagina.it':
			websiteCode = 'VP'
			break
		case 'casalelecorti.com':
			websiteCode = 'LC'
			break
		case 'ladigahotel.com':
			websiteCode = 'LD'
			break
		case 'villanorcenni.com':
			websiteCode = 'VN'
			break
		case 'ilmulinacciohotel.com':
			websiteCode = 'MU'
			break
		default:
			websiteCode = 'NG'
	}
	return websiteCode
};


export const getPrivacyLink = () => {
	let privacyLink;
	switch (getCurrentWebsite()) {
		case 'HU':
			privacyLink = 'https://huopenair.com/privacy-policy'
			break
		case 'NG':
			privacyLink = 'https://norcenni.huopenair.com/privacy-policy'
			break
		case 'AM':
			privacyLink = 'https://altomincio.huopenair.com/privacy-policy'
			break
		case 'PA':
			privacyLink = 'https://parkalbatros.huopenair.com/privacy-policy'
			break
		case 'MS':
			privacyLink = 'https://montescudaio.huopenair.com/privacy-policy'
			break
		case 'IP':
			privacyLink = 'https://ipini.huopenair.com/privacy-policy'
			break
		case 'BK':
			privacyLink = 'https://birkelt.huopenair.com/privacy-policy'
			break
		case 'CE':
			privacyLink = 'https://firenzecertosacamping.com/privacy-policy'
			break
		case 'RO':
			privacyLink = 'https://roma.huopenair.com/privacy-policy'
			break
		case 'CF':
			privacyLink = 'https://firenze.huopenair.com/privacy-policy'
			break
		case 'JO':
			privacyLink = 'https://venezia.huopenair.com/privacy-policy'
			break
		case 'FA':
			privacyLink = 'https://fabulous.huopenair.com/privacy-policy'
			break
		default:
			privacyLink = 'https://huopenair.com/privacy-policy'
	}
	return privacyLink;
};
